var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.376 13.207a1.11 1.11 0 01-1.502 0l-4.782-4.5a.959.959 0 010-1.414l4.782-4.5a1.11 1.11 0 011.502 0 .959.959 0 010 1.414L7.346 8l4.03 3.793a.959.959 0 010 1.414z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuMzc2MyAxMy4yMDcxQzEwLjk2MTQgMTMuNTk3NiAxMC4yODg2IDEzLjU5NzYgOS44NzM3IDEzLjIwNzFMNS4wOTI0NSA4LjcwNzExQzQuNjc3NTIgOC4zMTY1OCA0LjY3NzUyIDcuNjgzNDIgNS4wOTI0NSA3LjI5Mjg5TDkuODczNyAyLjc5Mjg5QzEwLjI4ODYgMi40MDIzNyAxMC45NjE0IDIuNDAyMzcgMTEuMzc2MyAyLjc5Mjg5QzExLjc5MTIgMy4xODM0MiAxMS43OTEyIDMuODE2NTggMTEuMzc2MyA0LjIwNzExTDcuMzQ2MzUgOEwxMS4zNzYzIDExLjc5MjlDMTEuNzkxMiAxMi4xODM0IDExLjc5MTIgMTIuODE2NiAxMS4zNzYzIDEzLjIwNzFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgLeftArrow as ReactComponent };